<template>
    <or-textbox
        ref="textbox"
        class="text-intent"
        :placeholder="$t('common.intent.types.text_intent.placeholder')"
        v-model="localIntent"
        :readonly="$props.readonly"
        :error="$props.errors && $props.errors.name"
        :invalid="!!($props.errors && $props.errors.name)"
        show-error-text="persistently"
        multi-line
    />
</template>

<script>
import { OrTextbox } from '@onereach/ui'

export default {
  components: { OrTextbox },

  props: {
    intent: String,
    readonly: Boolean,
    errors: Object
  },

  computed: {
    localIntent: {
      get () {
        return this.intent
      },
      set (value) {
        this.$emit('update:intent', value)
      }
    }
  },
  watch: {
    intent () {
      this.$nextTick(() => {
        this.$refs.textbox.refreshSize()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
    .text-intent {
        width: 100%;

        ::v-deep .ui-textbox__wr-input-feedback {
            .ui-textbox__textarea {
                border: none;
                background-color: $or-white;
                color: $or-black-blue;
                padding: $sp-1 0;
            }
        }
    }
</style>

<style lang="scss">
.text-intent {
    .ui-textbox__content {
        max-height: 100%;
        overflow: auto;
    }
}
</style>
